import { render } from "./mvt-searchbox.vue?vue&type=template&id=4cef0325"
import script from "./mvt-searchbox.js?vue&type=script&lang=js"
export * from "./mvt-searchbox.js?vue&type=script&lang=js"

import "./mvt-searchbox.vue?vue&type=style&index=0&id=4cef0325&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__